// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"9e4e2bba","333":"9b99c0c5","521":"d45ef41a","866":"fce52d20","901":"fc5b7589","903":"e41e6ea0","940":"2b99e2e7","952":"ef072c15","993":"9ac34527"}[chunkId] + ".chunk.js";
};